<input #input
       [(ngModel)]="userInput"
       [typeaheadAsync]="isAsync"
       [typeahead]="autoCompleteConfig.dataSource"
       (typeaheadLoading)="changeTypeaheadLoading($event)"
       (typeaheadOnSelect)="typeaheadOnSelect($event)"
       [typeaheadOptionField]="autoCompleteConfig.optionTextField"
       [typeaheadItemTemplate]="itemTemplate"
       [attr.placeholder]="autoCompleteConfig?.placeholder"
       [attr.name]="autoCompleteConfig?.nameAttribute"
       [attr.required]="autoCompleteConfig?.required"
       class="form-control"
       autocomplete="off"
       type="text"
       (change)="onChange()">

<ng-template #itemTemplate let-model="item" let-index="index">
  <div [style.width.px]="inputRef?.nativeElement?.offsetWidth - 40"
       style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
    {{model[autoCompleteConfig.optionTextField]}}
  </div>
</ng-template>

<button class="btn-search" type="button">
  <img *ngIf="typeaheadLoading" class="inputLoadingImg" src="assets/circle-loading-animation.gif">
  <span *ngIf="!typeaheadLoading && autoCompleteConfig.showSearchIcon" (click)="onSearchClick()"><app-svg-icon [type]="'Search'" [className]="'icon'"></app-svg-icon></span>
</button>
